export default __webpack_public_path__ + "static/media/11.20.58ebef0c.jpg";